import { render } from "./ic-close-big.vue?vue&type=template&id=054bb80e"
import script from "./ic-close-big.vue?vue&type=script&lang=js"
export * from "./ic-close-big.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__